"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletV3R2Source = void 0;
const __1 = require("../..");
class WalletV3R2Source {
    constructor(opts) {
        this.type = 'org.ton.wallets.v3.r2';
        this.walletVersion = 'v3';
        this.backup = () => {
            const store = new __1.ConfigStore();
            store.setInt('wc', this.workchain);
            store.setInt('walletId', this.walletId);
            store.setBuffer('pk', this.publicKey);
            return store.save();
        };
        this.describe = () => {
            return `Wallet V3 Contract (R2). WalletID = ${this.walletId}`;
        };
        this.publicKey = opts.publicKey;
        this.workchain = opts.workchain;
        this.walletId = opts.walletId;
        this.initialCode = opts.initialCode;
        this.initialData = opts.initialData;
        Object.freeze(this);
    }
    static create(opts) {
        // Resolve parameters
        let publicKey = opts.publicKey;
        let workchain = opts.workchain;
        let walletId;
        if (opts.walletId !== null && opts.walletId !== undefined) {
            walletId = opts.walletId;
        }
        else {
            walletId = 698983191 + workchain;
        }
        // Build initial code and data
        let initialCode = __1.Cell.fromBoc('B5EE9C724101010100710000DEFF0020DD2082014C97BA218201339CBAB19F71B0ED44D0D31FD31F31D70BFFE304E0A4F2608308D71820D31FD31FD31FF82313BBF263ED44D0D31FD31FD3FFD15132BAF2A15144BAF2A204F901541055F910F2A3F8009320D74A96D307D402FB00E8D101A4C8CB1FCB1FCBFFC9ED5410BD6DAD')[0];
        let initialData = new __1.Cell();
        initialData.bits.writeUint(0, 32);
        initialData.bits.writeUint(walletId, 32);
        initialData.bits.writeBuffer(publicKey);
        // Build contract source
        return new WalletV3R2Source({
            publicKey,
            workchain,
            walletId,
            initialCode,
            initialData
        });
    }
    static restore(backup) {
        const store = new __1.ConfigStore(backup);
        return WalletV3R2Source.create({ publicKey: store.getBuffer('pk'), workchain: store.getInt('wc'), walletId: store.getInt('walletId') });
    }
}
exports.WalletV3R2Source = WalletV3R2Source;
